// import Map from "../components/map.js";
import { BrowserRouter as Router, Route, useHistory, useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography } from '@material-ui/core';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import Map3D from './components/Map3D';
import Map2D from "./components/Map2D";
import MapSpecs from "./mapspec/mapspecs.js";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    margin: "0px",

    display: "flex",
    flexDirection: "column",
  },
  floatingSelectorContainer: {
    flexShrink: "1",
    flexGrow: "0",
  },
  mapContainer: {
    position: "relative",
    flex: "1 1 auto",
    overlow: "auto",
  },

  map2DPage: {
    position: "relative",
    overlow: "auto",

    height: "100%",

    // display: "flex",
    // flexDirection: "column",
  }
}));

function Map2DPage({ mapType }) {
  const history = useHistory();
  const classes = useStyles();

  function movePage(newMapType) {
    if (!newMapType) {
      return;
    }
    history.push("/" + newMapType);
  }
  return <div className={classes.map2DPage}>
    <ToggleButtonGroup
      value={mapType}
      exclusive
      onChange={(e, newMapType) => movePage(newMapType)}
      aria-label="map type"
    >
      {
        Object.entries(MapSpecs)
          .filter(([id, spec]) => spec.mapGroup === "2D")
          .map(([id, spec]) =>
            <ToggleButton key={id} value={id} aria-label={spec.description}>
              {spec.description}
            </ToggleButton>
          )
      }
    </ToggleButtonGroup>
    <Map2D mapType={mapType} />
  </div >;
}

function MainPage({ mapType }) {
  const history = useHistory();
  const mapSpec = MapSpecs[mapType];

  const classes = useStyles();

  function movePage(newMapType) {
    if (!newMapType) {
      return;
    }
    history.push("/" + newMapType);
    // const newMapSpec = MapSpecs[newMapType];
    // console.log(mapSpec.mapGroup + " " + newMapSpec.mapGroup);
    // // if (newMapSpec.mapGroup === "3D") {
    // if (mapSpec.mapGroup === "2D" && newMapSpec.mapGroup === "3D") {
    //   console.log("refresh");
    //   // Refresh page to allow Map 3D to reboot.
    //   history.go(0);
    // }
  }

  const [first2DID, first2DSpec] =
    Object.entries(MapSpecs).filter(([id, spec]) => spec.mapGroup === "2D")[0];

  return <>
    <div className={classes.root}>

      <div className={classes.floatingSelectorContainer}>
        <Typography variant="h5">
          富士山🗻が見える建物マップ
        </Typography>

        <Typography variant="body2">
          <a href="https://www.mlit.go.jp/plateau/" target="_blank">Plateau</a>のデータを使って計算した「都心で富士山が見える建物」地図です。建物の立体情報に基づき、富士山までの視線が他の建物に遮蔽されない建物を全て赤く表示しています。急に「富士山見てぇ！」となったときにご利用ください。
          作者：<a href="https://twitter.com/kenkawakenkenke" target="_blank">河本健</a>
          {" - "}<a href="https://kenkawakenkenke.hateblo.jp/entry/2021/03/31/224645" target="_blank">解説記事</a>
        </Typography>


        <ToggleButtonGroup
          value={mapType}
          exclusive
          onChange={(e, newMapType) => movePage(newMapType)}
          aria-label="map type"
        >
          {
            Object.entries(MapSpecs)
              .filter(([id, spec]) => spec.mapGroup == "3D")
              .map(([id, spec]) =>
                <ToggleButton key={id} value={id} aria-label={spec.description}>
                  {spec.description}
                </ToggleButton>
              )
          }
          <ToggleButton key={first2DID} value={first2DID} aria-label={first2DSpec.description}>
            2D地図
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      {<div className={classes.mapContainer}>
        {mapSpec.mapGroup === "3D" &&
          <Map3D mapType={mapType} />
        }
        {mapSpec.mapGroup === "2D" &&
          <Map2DPage mapType={mapType} />
        }
      </div>}


    </div>
  </>;
}

function MainPageRouter() {
  const { mapType } = useParams();
  const mergedMapType = mapType || "fuji3D";

  return <MainPage mapType={mergedMapType} />;
}

function App() {
  return <Router>
    <Route exact path="/" component={MainPageRouter} />
    <Route exact path="/:mapType" component={MainPageRouter} />
  </Router>;
  return <MainPage />
}

export default App;
